import { render, staticRenderFns } from "./FootPC.vue?vue&type=template&id=6677ff96&scoped=true"
import script from "./FootPC.vue?vue&type=script&lang=js"
export * from "./FootPC.vue?vue&type=script&lang=js"
import style0 from "./FootPC.vue?vue&type=style&index=0&id=6677ff96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6677ff96",
  null
  
)

export default component.exports